import { Component, EventEmitter, Output, input } from '@angular/core';
import { MenuItem } from '@coin/admin/core/util';

@Component({
  selector: 'coin-a-app-cards',
  templateUrl: './app-cards.component.html',
  styleUrls: ['./app-cards.component.scss'],
  standalone: false
})
export class AppCardsComponent {
  readonly menuItems = input<MenuItem[]>(undefined);
  readonly type = input<'primary' | 'secondary'>('primary');
  readonly translationPrefix = input<string>(undefined);

  @Output() openClicked: EventEmitter<MenuItem> = new EventEmitter<MenuItem>();

  public get activeMenuItems(): MenuItem[] {
    return this.menuItems()?.filter(menuItem => menuItem.active);
  }
}
